module.exports = __webpack_public_path__ + "d01d4db43ef6213f134e7e84338738b6.webp";